
import { components } from '@/models/jobDetailed';
type Product = components['schemas']['Product'];
type ProductsType = components['schemas']['Stop']['pickup_products'];

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Products extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  @Prop({ type: Object, default: () => {} }) public readonly products!: ProductsType;

  public get numberOfProducts(): number {
    return Object.keys(this.products).length;
  }

  public copyProductName(product: Product | Record<string, never>): void {
    const copyText = document.createElement('input');
    copyText.value = `${product.serial} ${product.model}`;
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    document.body.removeChild(copyText);
    this.$notify({
      group: 'network',
      text: 'Product copied',
      type: 'success',
      duration: 3000,
    });
  }

  /** Returns a link to the Quant page in Odoo WH */
  public warehouseLink = (item: Product | Record<string, never>): string => {
    return `${process.env.VUE_APP_URL}/web#id=${item.quant_id}&view_type=form&model=stock.quant&action=176`;
  };
}
